var map = {
	"./navBar": "./src/permissions/navBar.ts",
	"./navBar.ts": "./src/permissions/navBar.ts",
	"./sideBar": "./src/permissions/sideBar.ts",
	"./sideBar.ts": "./src/permissions/sideBar.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/permissions lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;